import axios from "axios";

export function api(options) {
    const method = (options.method || 'GET').toUpperCase();
    const params = { ...(options.params || {}) };
    const request = { method, baseURL: baseUrl, url: options.endpoint };
    if (method === 'POST' || method === 'PUT') {
        params[csrf_name] = csrf_hash;
        request.data = new FormData();
        for (const [name, value] of Object.entries(params)) request.data.append(name, value);
    } else {
        request.params = params;
    }
    return axios.request(request).then(response => {
        options.successCallback?.(response);
        return response;
    }, error => {
        const details = error.response?.data || { message: 'Unable to reach the server. Please try again.' };
        // Callers expect an array, while CodeIgniter validation returns a field/message object.
        const errors = Array.isArray(details.errors) ? details.errors :
            Object.values(details.errors || { request: details.message || 'Request failed' }).map(message => ({ message }));
        options.errorCallback?.({ ...details, errors });
    });
}

export function apiFiles(action, params, files, successCallback, errorCallback) {

    if(files.length > 0 ) {
        params.append("action", action);
        for (var x = 0; x < files.length; x++) {
            params.append("files[]", files[x]);
        }

        $.ajax({
            url: this.endpoint,
            type: 'POST',
            data: params,
            contentType: false,
            processData: false,
            success: function (data) {
                this.flashSuccess(data.message);
                this.spinner(false);

                if (!data.success) {
                    this.parseErrors(data.errors);
                    this.spinner(false);

                    if (typeof errorCallback === 'function') {
                        errorCallback.call(this);
                    }
                } else {
                    if (typeof successCallback === 'function') {
                        successCallback.call(this, data);
                    }
                }
            }.bind(this),
            error: function(e){
                this.parseErrors(e.responseJSON.errors);
                this.spinner(false);

                if (typeof errorCallback === 'function') {
                    errorCallback.call(this);
                }
            }.bind(this)
        });
    }
}

export default {api, apiFiles};